import { atom } from "recoil";

export const imagePreviewState = atom<string | null>({
  key: "imagePreviewState",
  default: null,
});
